import React, { useState, useEffect, Fragment } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorSection } from 'react-anchor-navigation';
import { Props } from './interfaces';
import './BlockCalculator.scss';
import './BlockCalculator-media.scss';
import Calculator from '../Calculator/Calculator';
import Content from '../Content/Content';
import CalculatorTable from '../CalculatorTable/CalculatorTable';
import { MediaContent } from '../../services/GlobalFunctions';
import {content} from "../../services/content";

const BlockCalculator = ({ calculator, alertLoaded }: Props) => {
  const { KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost } = calculator;

  const [valueFrom, setValueFrom] = useState('Москва');
  const [valueIn, setValueIn] = useState('');
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    let errorsCount = 0;
    [KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost].forEach((item) => {
      if (item.errormsg) {
        errorsCount++;
      }
    });

    if (errorsCount === 6) {
      setShowTable(false);
      alertLoaded([content.common.alertByParameter, `${KurSdek.errormsg}`]);
    }
  }, [calculator]);

  return (
    <>
      <Calculator
        buttonOnClick={() => setShowTable(true)}
        setCityFrom={setValueFrom}
        setCityIn={setValueIn}
      />
      <div className="block-calculator__bg"></div>

      <AnchorSection id="result">
        {showTable
          ? MediaContent(
              <Content
                padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 0, bottom: 40 } }}
                block={<CalculatorTable valueFrom={valueFrom} valueIn={valueIn} />}
              />,

              <CalculatorTable valueFrom={valueFrom} valueIn={valueIn} />
            )
          : null}
      </AnchorSection>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(BlockCalculator));
